import React, { FC, useEffect, useState } from 'react';
import { encryptId, formatPrice } from '../../../../../_metronic/helpers';
import { useHistory } from 'react-router-dom';

type Props = {
  board: any;
  onRefreshData: () => void;
};

const CardsProducts: FC<Props> = ({ board, onRefreshData }) => {
  const history = useHistory();

  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(board.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, board.length);

  const onPageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  useEffect(()=>{
    
      setCurrentPage(1)
    
  }, [onRefreshData])

  return (
    <>
      <div className="container mt-5">
        <div className="row ">
          {board.slice(startIndex, endIndex).map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="col-md-6 col-lg-6 col-xxl-4 col-xl-6 mb-3"
              >
                <div
                  className="card border h-100 cursor-pointer"
                  style={{ minHeight: '100px' }}
                  onClick={() => {
                    history.push(
                      `/cotizaciones/productos/edit/${encryptId(
                        item.id.toString()
                      )}`
                    );
                  }}
                >
                  {/* begin::Body */}
                  {/* align-items-center */}
                  <div className="card-body d-flex  align-items-center  pt-1 pb-0">
                    <div className="me-5 w-25">
                      {item.imagen ? (
                        <img
                          src={`${process.env.REACT_APP_PUBLIC}producto/${item?.imagen}`}
                          title={item.nombre}
                          crossOrigin="anonymous"
                          // className="h-100px"
                          className="w-100"
                          alt="producto"
                          style={{ borderRadius: '3px' }}
                        />
                      ) : (
                        <img
                          src={
                            process.env.PUBLIC_URL + '/media/avatars/photo.png'
                          }
                          alt=""
                          className="w-100"
                          // className="h-100px me-4"
                        />
                      )}
                    </div>

                    <div className="min-h-150px w-75">
                      <div className="fw-bolder text-gray-700 fs-4 mt-2 cursor-pointer w-100  large-text">
                        {item.nombre}
                      </div>

                      <div className="">
                        <div className="text-gray-500 fw-bolder fs-7 mt-2">
                          Precio venta
                        </div>
                        <div className="text-gray-500 fs-5">
                          <span
                            className="fs-6 fw-bold"
                            style={{ color: '#1B84FF' }}
                          >
                            {item.tipoPrecioVenta?.code === 'TPVF' ? (
                              <>
                                {' '}
                                {`${formatPrice(
                                  item.precio_fijo_venta || 0,
                                  'es-MX',
                                  'MXN',
                                  2,
                                  2
                                )}`}
                              </>
                            ) : (
                              <>
                                {' '}
                                {`${formatPrice(
                                  item.precio_objetivo_calculado_venta || 0,
                                  'es-MX',
                                  'MXN',
                                  2,
                                  2
                                )}`}
                              </>
                            )}
                          </span>
                          <span className="fs-8 mt-3 ms-2">
                            {item.unidadMonedaVenta && (
                              <>
                                /{' '}
                                <span data-kt-element="period">
                                  {item.unidadMonedaVenta.code}
                                </span>
                              </>
                            )}
                          </span>
                        </div>
                        <div className="text-gray-500  fs-7 mt-2 ">
                          <span className="fw-bolder">Precio venta final</span>
                          <span className="fs-8 mt-3 ms-2">
                            {item.aplica_impuesto_precio_venta ? (
                              <>{'( c/impuesto)'}</>
                            ) : (
                              <>{''}</>
                            )}
                          </span>
                        </div>
                        <div className="text-gray-500  fs-5 ">
                          <span
                            className="fs-6 fw-bold"
                            style={{ color: '#1B84FF' }}
                          >
                            {`${`${formatPrice(
                              item.precio_venta ?? 0,
                              'es-MX',
                              'MXN',
                              2,
                              2
                            )}`}`}
                          </span>
                          <span className="fs-8 mt-3 ms-2">
                            {item.unidadMonedaVenta && (
                              <>
                                /{' '}
                                <span data-kt-element="period">
                                  {item.unidadMonedaVenta.code}
                                </span>
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="text-gray-500 fw-bolder fs-9 mt-2 text-end">
                        <span>Inventario</span>
                      </div>
                      <div className="text-gray-500  fs-5 mb-4 text-end">
                        <span
                          className="fs-7 fw-bold"
                          style={{ color: '#1B84FF' }}
                        >
                          {item.inventario}
                        </span>
                        <span className="fs-9 mt-3 ms-1">
                          {item.unidadMedidaVenta && (
                            <>
                              /{' '}
                              <span data-kt-element="period">
                                {item.unidadMedidaVenta.code}
                              </span>
                            </>
                          )}
                        </span>
                      </div>

                      {/* <p className="text-muted text-gray-600">
                        {item.inventario}
                      </p> */}
                    </div>
                  </div>
                  {/* end::Body */}
                  <span className="position-absolute opacity-15 bottom-0 start-0 border-4 border-primary border-bottom w-100"></span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="row justify-content-center">
          <nav aria-label="Navegación de página">
            <ul className="pagination">
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    currentPage === i + 1 ? 'active' : ''
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => onPageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export { CardsProducts };
